







































import BasicInfo from "@/components/BasicInfo.vue";
import Disclaimer from "@/components/Disclaimer.vue";
import Goals from "@/components/Goals.vue";
import MacroCalc from "@/components/MacroCalc.vue";
import Vue from "vue";
import Component from "vue-class-component";

@Component({
  components: {
    Disclaimer,
    BasicInfo,
    MacroCalc,
    Goals
  }
})
export default class Skeleton extends Vue {
  get page() {
    return this.$store.state.utils.page;
  }
}
